import React, { Component } from 'react';
import Layout from '../../ui/Layout';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { Redirect } from 'react-router';
import MetaTags from 'react-meta-tags';

import fetchDux from '../../../state/fetch-dux';
import MetaLoader from '../../ui/MetaLoader';

class CheckoutConfirmationPage extends Component {
  componentDidMount() {
    window.scrollTo(0, 0);
    this.props.clearGetCart();
    this.props.clearGetCartBilling();
    this.props.clearGetCartShipping();
    document.body.classList.add(
      'page-template',
      'page-template-page-templates',
      'page-template-shop-template-cart-shipping',
      'page-template-page-templatesshop-template-cart-shipping-php',
      'page',
      'page-id-237',
      'page-child',
      'parent-pageid-212',
      'no-sidebar'
    );
  }
  componentWillUnmount() {
    this.props.clearPostCompleteOrder();
    this.props.clearGetCart();
    this.props.clearGetCartBilling();
    this.props.clearGetCartShipping();
    document.body.classList.remove(
      'page-template',
      'page-template-page-templates',
      'page-template-shop-template-cart-shipping',
      'page-template-page-templatesshop-template-cart-shipping-php',
      'page',
      'page-id-237',
      'page-child',
      'parent-pageid-212',
      'no-sidebar'
    );
  }
  render() {
    const scrollToTop = () => window.scrollTo(0, 0);
    const {
      order
    } = this.props;
    const {
      billingAddress,
      purchaseOrderId,
      total,
      tax,
      freight,
      items
    } = order || {};
    const { email } = billingAddress || {};

    if (!purchaseOrderId) return <Redirect to="/shop" />;

    // if the data layer is available
    if (window && window.dataLayer) {
      const transactionProducts = (items || []).map(({
        quantity,
        productId,
        description,
        kitPrice
      }) => ({
        sku: productId,
        name: description,
        price: kitPrice,
        quantity
      }));

      const gaEcomm = {
        event: 'order-confirmation',
        transactionId: purchaseOrderId,
        transactionAffiliation: 'Twomey.com',
        transactionTotal: total,
        transactionTax: tax,
        transactionShipping: freight,
        transactionProducts: transactionProducts
      };

      window.dataLayer.push(gaEcomm);
    }

    return (
      <Layout route="checkout">
        <MetaLoader title="Confirmation | Checkout | Twomey Cellars" />
        <MetaTags>
          <title>Confirmation | Checkout | Twomey Cellars</title>
          <meta property="og:site_name" content="Twomey.com" />
          <meta
            property="og:title"
            content="Confirmation | Checkout | Twomey Cellars"
          />
          <meta property="og:type" content="article" />
          <meta
            property="og:url"
            content="https://twomey.com/shop/checkout/confirmation"
          />
        </MetaTags>
        <div id="content" className="site-content">
          <div id="primary" className="content-area">
            <main id="main" className="site-main shop-page nohero cart-page">
              <div className="container">

                <h1 className="h3-style column-header">
                  Order Confirmation
                </h1>

                <div className="account-sections">
                  <h2 className="h1-confirmation-style column-header">
                    Thank You!
                  </h2>
                  <p>
                    Your order number is
                    {' '}
                    <strong>{purchaseOrderId}</strong>
                    .
                    {' '}
                    <br />
                    An email confirmation has been sent to
                    {' '}
                    <strong>{email}</strong>
                    .
                  </p>
                  <br />
                  <h5>What’s Next?</h5>
                  <p>
                    Orders are processed within 24 - 48 hours of receipt. To ensure
                    your wine’s integrity during extreme temperatures, we
                    may hold your shipment.
                    <br />
                    {' '}
                    Please contact us if you have any
                    questions, we are available Monday - Friday, 8am to 5pm PT (888) 202-2006.
                  </p>
                  <a href="/" className="return-home-link">
                    Return to twomey.com
                  </a>
                </div>

              </div>
            </main>
          </div>
          <div className="container text-right">
            <a href="#top" className="back-to-top" onClick={scrollToTop}>
              Back to top
            </a>
          </div>
        </div>
      </Layout>
    );
  }
}

const mapState = state => {
  const {
    result: order
  } = state.postCompleteOrder.toJS();
  return {
    order
  };
};

const mapDispatch = dispatch =>
  bindActionCreators(
    {
      clearPostCompleteOrder: fetchDux.postCompleteOrder.clearAction,
      clearGetCart: fetchDux.getCart.clearAction,
      clearGetCartBilling: fetchDux.getCartBilling.clearAction,
      clearGetCartShipping: fetchDux.getCartShipping.clearAction
    },
    dispatch
  );

export default connect(mapState, mapDispatch)(CheckoutConfirmationPage);
